var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createElement, memo } from 'react';
import { Link } from 'react-router-dom';
import { transform } from 'js/css-transform';
import HTML from 'html-parse-stringify';
import { Alert } from 'react-bootstrap';
import _ from 'lodash';
import he from 'he';
import { isExternal } from 'helpers/http';
import BackgroundElementFTs from 'cc-editor/components/BlockTs/BackgroundElementFTs';
import DropdownElementFTs from 'cc-editor/components/BlockTs/DropdownElementFTs';
import PreviewImageElementFTs from './BlockTs/PreviewImageElementFTs';
import PreviewEditableFTs from './BlockTs/PreviewEditableFTs';
import BlockContainerFTs from './BlockTs/BlockContainerFTs';
import DraggableContainerFTs from './BlockTs/DraggableContainerFTs';
import QRCodeWithLogoFTs from 'cc-editor/components/BlockTs/QRCodeWithLogoFTs';
import QRCode from './Block/QRCode';
import { useSelector } from 'react-redux';
import { getCorporateDesignClient, getCorporateDesignLogoUrl } from 'cc-editor/helpers/corporateDesign';
const PreviewBlockFTs = (props) => {
    var _a;
    const { index, data, type, appIntl, rasterV, updateParam, srcThumb, currentPage, setSelectedColor, setFontSizeSettings, fontSizeSettings, getColorSettings, updateInnerBlock, usedMedia, blockContainerId, pageZoom, settings, colorSettings, updateBlocksState } = props;
    const editionRV = (_a = useSelector((state) => state.editor.editionRV)) !== null && _a !== void 0 ? _a : props.editionRV;
    const qrVariables = React.useMemo(() => {
        const client = getCorporateDesignClient(editionRV);
        const profile = (client === null || client === void 0 ? void 0 : client.profile) || {};
        const website = profile.website ? String(profile.website).replace(/^https?:\/\//, '') : '';
        return {
            website,
            companyName: profile.company,
            addCompanyName: profile.company_name,
            street: profile.street,
            zipCode: profile.zip_code,
            city: profile.city,
            phone: profile.phone,
            email: profile.email,
            slogan1: profile.slogan1,
            slogan2: profile.slogan2,
            herausgeber: '',
        };
    }, [editionRV]);
    const forbiddenTags = ['iframe', 'script'];
    const allowedAttributes = ['class', 'style', 'colspan', 'href', 'target', 'src', 'alt'];
    const getLinkData = ({ name, attributes }) => {
        const isLinkExternal = isExternal(attributes.href);
        const decodedHref = he.decode(attributes.href);
        return {
            name: isLinkExternal ? name : Link,
            attributes: Object.assign(Object.assign({}, attributes), (isLinkExternal ? { href: decodedHref } : { to: decodedHref })),
        };
    };
    const loop = (elements) => {
        let result = [];
        let counter = 0;
        _.forEach(elements, (value, key) => {
            counter++;
            if (value.type === 'text') {
                result.push(he.decode(value.content));
                return;
            }
            if (value.type === 'tag' && !_.includes(forbiddenTags, value.name)) {
                let { name } = value;
                let attributes = {};
                _.forEach(value.attrs, (attr, attrKey) => {
                    switch (attrKey) {
                        case 'class':
                            attributes.className = attr;
                            break;
                        case 'style':
                            if (attr) {
                                try {
                                    attributes[attrKey] = transform(attr);
                                }
                                catch (err) {
                                    console.log('error', err);
                                }
                            }
                            break;
                        case 'data-background':
                            _.forEach(data.params, (param) => {
                                if (param.name === value.attrs['data-name']) {
                                    const parsedParam = HTML.parse(param.value);
                                    _.forEach(parsedParam, (paramContent) => {
                                        if (paramContent.name === 'meta') {
                                            attributes.className = `${attributes.className} ${paramContent.attrs.content}`;
                                        }
                                    });
                                }
                            });
                            break;
                        default:
                            attributes[attrKey] = attr;
                            break;
                    }
                });
                if (name === 'a') {
                    ({ name, attributes } = getLinkData({ name, attributes }));
                }
                else if (['html', 'head', 'body'].includes(name)) {
                    name = 'div';
                }
                // Remove any 'key' from the HTML template that may have slipped in
                const { key: _ignoredTemplateKey } = attributes, cleanAttributes = __rest(attributes, ["key"]);
                attributes = cleanAttributes;
                // Unique React key for the list
                const elementKey = `preview_${data.id}_${counter}_${key}`;
                // 🧩 All special components
                const className = attributes.className || '';
                if (name === 'img' && className.includes('editable')) {
                    result.push(_jsx(PreviewImageElementFTs, { index: index, name: "img", attributes: attributes, params: data.params, srcThumb: srcThumb, settings: settings }, elementKey));
                }
                else if (['img', 'br', 'hr'].includes(name)) {
                    const editionRV = useSelector((state) => state.editor.editionRV);
                    const cdClient = getCorporateDesignClient(editionRV);
                    if (attributes.src !== undefined) {
                        attributes.src = attributes.src.replace('{logoBlack}', getCorporateDesignLogoUrl(cdClient, 'client_main_logo'));
                        attributes.src = attributes.src.replace('{logoWhite}', getCorporateDesignLogoUrl(cdClient, 'client_main_logo_white'));
                        attributes.src = attributes.src.replace('{logoColored}', getCorporateDesignLogoUrl(cdClient, 'client_main_logo_multi_colored'));
                    }
                    // Pass the key directly, do not spread it from attributes
                    result.push(createElement(name, Object.assign({ key: elementKey }, attributes)));
                    return;
                }
                else if (className.includes('block-container')) {
                    result.push(_jsx(BlockContainerFTs, { appIntl: appIntl, id: data.id, name: name, attributes: attributes, children: value.children, blocks: data.blocks, type: type, rasterV: rasterV, currentPage: currentPage, setSelectedColor: setSelectedColor, setFontSizeSettings: setFontSizeSettings, fontSizeSettings: fontSizeSettings, getColorSettings: getColorSettings, updateInnerBlock: updateInnerBlock, usedMedia: usedMedia, settings: settings, pageZoom: pageZoom, spaceConsumed: data.space_consumed, spaceTotal: data.containerSpace, data: data, colorSettings: colorSettings, updateBlocksState: updateBlocksState }, elementKey));
                }
                else if (className.includes('ContainerDraggable')) {
                    result.push(_jsx(DraggableContainerFTs, { appIntl: appIntl, id: data.id, name: name, attributes: attributes, children: value.children, blocks: data.blocks, type: type, rasterV: rasterV, setFontSizeSettings: setFontSizeSettings, fontSizeSettings: fontSizeSettings, currentPage: currentPage, setSelectedColor: setSelectedColor, getColorSettings: getColorSettings, updateInnerBlock: updateInnerBlock, usedMedia: usedMedia, settings: settings, pageZoom: pageZoom, spaceConsumed: data.space_consumed, spaceTotal: data.containerSpace, data: data, colorSettings: colorSettings, updateBlocksState: updateBlocksState }, elementKey));
                }
                else if (className.includes('dropdownmenu')) {
                    result.push(_jsx(DropdownElementFTs, { appIntl: appIntl, id: data.id, name: name, attributes: attributes, params: data.params }, elementKey));
                }
                else if (className.includes('editable')) {
                    result.push(_jsx(PreviewEditableFTs, { index: index, name: name, attributes: attributes, children: value.children, params: data.params, id: data.id, setFontSizeSettings: setFontSizeSettings }, elementKey));
                }
                else if (className.includes('qr-logo-code')) {
                    result.push(_jsx(QRCodeWithLogoFTs, { name: name, attributes: attributes, params: data.params, appIntl: appIntl, variables: qrVariables }, elementKey));
                }
                else if (className.includes('qr-code')) { /* legacy */
                    result.push(_jsx(QRCode, { name: name, attributes: attributes, params: data.params, variables: qrVariables }, elementKey));
                }
                else if (className.includes('backgroundOptions')) {
                    result.push(_jsx(BackgroundElementFTs, { appIntl: appIntl, id: data.id, name: name, attributes: attributes, params: data.params, block: data, value: value, currentPage: currentPage, setSelectedColor: setSelectedColor, updateParam: updateParam, blockContainerId: blockContainerId, settings: settings, colorSettings: colorSettings, updateBlocksState: updateBlocksState }, elementKey));
                }
                /* else if (_.includes(attributes.className, 'nav')) {
                    result.push(
                      <NavigationElement
                        key={elementKey}
                        appIntl={appIntl}
                        id={data.id}
                        name={name}
                        attributes={attributes}
                        params={data.params}
                      />
                    );
                }  else if (className.includes('calendar')) {
                  result.push(
                    <CalendarElement
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('cal-optimized')) {
                  result.push(
                    <CalendarElementOptimized
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('video')) {
                  result.push(
                    <VideoElement
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('socialmedia')) {
                  result.push(
                    <SocialMediaElement
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('imagegallery')) {
                  result.push(
                    <ImageGalleryElement
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('biggallery')) {
                  result.push(
                    <ImageGalleryElementTwo
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('textslider')) {
                  result.push(
                    <TextSlider
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('slidertxtbig')) {
                  result.push(
                    <TextSliderTwo
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('contactform')) {
                  result.push(
                    <ContactFormElement
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('newform')) {
                  result.push(
                    <ContactFormElementNew
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('actionButton')) {
                  result.push(
                    <ActionButton
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('newmap')) {
                  result.push(
                    <GoogleMapsElement
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('rssfeeds')) {
                  result.push(
                    <RSSFeedsElement
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                    />
                  );
                } else if (className.includes('creatomate')) {
                  result.push(
                    <Creatomate
                      key={elementKey}
                      appIntl={appIntl}
                      id={data.id}
                      name={name}
                      attributes={attributes}
                      params={data.params}
                      updateParam={updateParam}
                    />
                  );
                } */ else if (attributes['data-is-root']) {
                    result = loop(value.children);
                }
                else {
                    // Pass the key directly, do not spread it from attributes
                    result.push(createElement(name, Object.assign({ key: elementKey }, attributes), loop(value.children)));
                }
            }
        });
        return result;
    };
    // ⚙️ Rendering
    if (data && data.template) {
        const cleanTemplate = data.template; // .replace(/>\s+</g, '><');
        try {
            return _jsx(_Fragment, { children: loop(HTML.parse(`<div data-is-root="true">${cleanTemplate}</div>`)) });
        }
        catch (e) {
            return (_jsx("div", { className: "rich-editor-content", children: _jsxs(Alert, { variant: "danger", children: [`${e}`, " Incorrect HTML detected. Please check your code in the editor."] }) }));
        }
    }
    return null;
};
export default memo(PreviewBlockFTs);
